const { innerHeight, innerWidth } = window;
const device = innerHeight > innerWidth ? 'mobile' : 'web';

export default device;
